import './App.css';
import { BrowserRouter, Switch, Route, useParams, state, Link, Redirect } from "react-router-dom";
import EnhancedTable from './Standings';
import ContestPage from './ContestPage';
import UserSta from './UserStandingPage';
import UserStandingPage from './UserStandingPage';

function App() {
  const ContestStanding = ({match}) => {
    return(
      <EnhancedTable contest={match.params.id}/>
    );
  }
  const UserStanding = ({match}) => {
    return(
      <UserStandingPage contest={match.params.id} user={match.params.user}/>
    );
  }
  return (
    <div className="App">
      <h1 style={{textAlign:'center'}}>Codedigger</h1>
        <BrowserRouter>
        
          <Switch>
            <Route exact path="/" component={ContestPage}/>
            <Route exact path="/contest/shortCode/:id/standing" component={ContestStanding}/>
            <Route exact path="/contest/shortCode/:id/standing/:user" component={UserStanding}/>
            <Redirect to='/' />
          </Switch>
          {/* <Route component={ErrorPage}/> */}
        </BrowserRouter>
    </div>
  );
}

export default App;


